/**
 * This file holds the tiered pricing logic in a single function,
 * making it easy to modify or reuse.
 */

const pricingBrackets = [
    { name: "Bracket 1: Vehicle #1",      count: 1,   price: 69 },
    { name: "Bracket 2: Vehicles 2-5",    count: 4,   price: 59 },
    { name: "Bracket 3: Vehicles 6-10",   count: 5,   price: 49 },
    { name: "Bracket 4: Vehicles 11-50",  count: 40,  price: 39 },
    { name: "Bracket 5: Vehicles 51-100", count: 50,  price: 29 },
    { name: "Bracket 6: Vehicles 101-250",count: 150, price: 19 },
    { name: "Bracket 7: Vehicles 251-499",count: 249, price: 9 },
    { name: "Bracket 8: Vehicles 500-999",count: 500, price: 7 }
  ];
  
  /**
   * Calculates the monthly subscription cost for a given fleet size.
   * If 'fleetSize >= 1000', applies a flat rate of $7/vehicle.
   */
  export function calculateSubscriptionCost(fleetSize) {
    if (fleetSize >= 1000) {
      return fleetSize * 7;
    }
  
    let totalCost = 0;
    let remaining = fleetSize;
  
    for (const bracket of pricingBrackets) {
      const vehiclesInBracket = Math.min(remaining, bracket.count);
      totalCost += vehiclesInBracket * bracket.price;
      remaining -= vehiclesInBracket;
      if (remaining <= 0) {
        break;
      }
    }
  
    return totalCost;
  }